import type { ICustomControlProcedureReadProps } from '../../../interfaces/';
import { UserTextParagraph } from '../../../../../elements/common';
import { FormLabel } from '../../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../../elements/forms/InputContainer';
import { ProcedureThumbnails } from '../../../utils/v1/ProcedureThumbnails';

export function PilotExaminationV1ProcedureSummary(props: ICustomControlProcedureReadProps) {
    return (
        <>
            <ProcedureThumbnails {...props} />

            {props.procedure.customControlData.metingen && (
                <HorizontalFormGroupRead>
                    <FormLabel>Metingen</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.procedure.customControlData.metingen}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
